// Packages
import { createAsyncThunk } from '@reduxjs/toolkit';
// API
import { ReportsApi } from 'api/endpoints';
// Interfaces and types
import { IGetTardyReportRes } from 'types/tardyReportTypes';
import { TQueryParams, IErrorRes } from 'types/appTypes';

const getTardyReportAsync = createAsyncThunk<
  IGetTardyReportRes,
  TQueryParams,
  { rejectValue: IErrorRes }
>('reports/getTardyReportThunk', async (params: TQueryParams, { rejectWithValue }) => {
  try {
    return await ReportsApi.getTardyReport(params);
  } catch (error) {
    return rejectWithValue(error as IErrorRes);
  }
});

export { getTardyReportAsync };
